export default __webpack_public_path__ + "static/logo-a63854f1e39fb85fd1fd6046b42ce1b7.svg";